import { useEffect, useState } from 'react'
import { Accordion, Button, Card, Form, Table } from 'react-bootstrap';
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext';
import moment from 'moment';
import AppointmentDetail from './AppointmentDetail';
import AppointmentCreate from './AppointmentCreate';
import { getAppointmentExcelResult, getAppointmentGroupsByDate/*, getAppointmentsByExpertId*/ } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments';
import { /*GetAppointmentByIdOutput,*/ GetAppointmentGroupsByDateOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels';
import AppointmentCreateForGrouppedData from './AppointmentCreateForGrouppedData';

// type Props = {}

const AppointmentGroupTable =/*: React.FC<Props> = ({})*/() => {

    const [appointmentGroups, setAppointmentGroups] = useState<GetAppointmentGroupsByDateOutput[] | null>(null)
    const [filteredAppointmentGroups, setFilteredAppointmentGroups] = useState<GetAppointmentGroupsByDateOutput[] | null>(null)
    useEffect(() => {
        getAppointmentGroupsByDate()
            .then((response) => {

                setFilteredAppointmentGroups(response.data)

                const newAppointmentGroups = response.data?.filter(ag => new Date(ag.appointmentDate) > new Date())
                setAppointmentGroups(newAppointmentGroups ?? [])
            })
            .catch((error) => {
                console.error("Error fetching appointment groups:", error);
            });
    }, []);

    const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null);

    const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveAccordion(eventKey === activeAccordion ? null : eventKey);
    };

    const [showOldAppointments, setShowOldAppointments] = useState<boolean>(false);

    const handleToggleOldAppointments = () => {
        setShowOldAppointments(!showOldAppointments);
        // console.log(showOldAppointments, new Date())
        if (showOldAppointments) {
            const newAppointmentGroups = filteredAppointmentGroups?.filter(ag => new Date(ag.appointmentDate) > new Date())
            setAppointmentGroups(newAppointmentGroups ?? [])
        }
        else {
            setAppointmentGroups(filteredAppointmentGroups)
        }
    };

    const handleExcelResultClick = (appointmentDate: Date) => {
        // Butona tıklandığında yapılacak işlemler buraya yazılır
        console.log('Butona tıklandı!');

        getAppointmentExcelResult(appointmentDate)
    };

    return (
        <div className='card p-5'>
            <div className='card-header'>
                <div className='d-flex align-items-center'>
                    <Form.Switch
                        id="showOldAppointmentsSwitch"
                        label="Eski Randevuları Göster"
                        checked={showOldAppointments}
                        onChange={handleToggleOldAppointments} />
                </div>
                <AppointmentCreate appointmentStartDate={null} />
            </div>
            <div>
                {appointmentGroups && appointmentGroups.length > 0 ? (
                    <div>
                        <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
                            {appointmentGroups.map((appointmentGroup, index) => (
                                <Card key={index}>
                                    <Card.Header>
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                            <Button className='d-flex justify-content-between align-items-center w-100' variant='link' onClick={(e) => toggleAccordion(index.toString(), e)}>
                                                <div className='text-left'>
                                                    {moment(appointmentGroup.appointmentDate).format('DD MMMM YYYY')}
                                                </div>
                                                <div className='text-center text-gray-700 fs-7'>
                                                    <div>
                                                        <span className='text-left'>
                                                            İlk Randevu: {' '}
                                                            {
                                                                appointmentGroup.appointmentHoursGroup.reduce((total, ag) => {
                                                                    const count = ag.appointmentDetails.filter(
                                                                        (ad) => ad.appointmentId > 0 && ad.isFirstAppointment === true
                                                                    ).length;
                                                                    return total + count;
                                                                }, 0)
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className='p-5'>
                                                            Kontrol: {' '}
                                                            {
                                                                appointmentGroup.appointmentHoursGroup.reduce((total, ag) => {
                                                                    const count = ag.appointmentDetails.filter(
                                                                        (ad) => ad.appointmentId > 0 && ad.isFirstAppointment === false
                                                                    ).length;
                                                                    return total + count;
                                                                }, 0)
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='text-right'>
                                                </div>
                                            </Button>
                                            <div></div>
                                            <button
                                                type="button"
                                                about='Excel'
                                                title='Randevu Bilgilerini İndir'
                                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                onClick={() => handleExcelResultClick(appointmentGroup.appointmentDate)}>
                                                <i className="ki-duotone ki-file-down fs-2"><span className="path1"></span><span className="path2"></span></i>
                                                {/* Randevu Listesi */}
                                            </button>
                                        </div>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey={index.toString()}>
                                        <Card.Body>
                                            <Table bordered>
                                                <thead>
                                                    <tr>
                                                        <th>Randevu Saatleri</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {appointmentGroup.appointmentHoursGroup.map((appointmentHourGroups, groupIndex) => (
                                                        <tr key={groupIndex}>
                                                            {appointmentHourGroups.appointmentDetails.map((appointmentDetail, adIndex) =>
                                                                //#FFCDD2       //#A5D6A7
                                                                <td className='p-0' key={adIndex} style={appointmentDetail.appointmentId && appointmentDetail.appointmentId > 0 ? { backgroundColor: "#FFCDD2" } : { backgroundColor: "#A5D6A7" }}>
                                                                    {appointmentDetail.appointmentId && appointmentDetail.appointmentId > 0 ?
                                                                        (
                                                                            <AppointmentDetail appointmentDetail={appointmentDetail} />
                                                                        ) :
                                                                        <AppointmentCreateForGrouppedData appointmentDetail={appointmentDetail} />
                                                                    }
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </Table>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            ))}
                        </Accordion>
                    </div>) :
                    (<div>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                                <span className="text-gray-400 fw-bold text-hover-primary d-block fs-6">RANDEVU BULUNAMADI.</span>
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    );
}

export default (AppointmentGroupTable)